import anime from 'animejs'
import { $1, $, each } from '../util'

const ModalManager = (() => {
  let isAnimating = false

  const hideModal = () => {
    const modal = $1('.c-contacts-modal')
    if (modal) {
    const modalContent = $1('.c-contacts-modal__content')
    const modalClose = $1('.c-contacts-modal__close')
    const image = $1('.c-contacts-modal__image')
    const shapeLeft = $1('.c-contacts-modal__image-shape--left')
    const shapeRight = $1('.c-contacts-modal__image-shape--right')

    const immediate = $1('.c-contacts-immediate')
    
    const text = modal.querySelector('.c-contacts__text')
    const title = modal.querySelector('.c-contacts__title')
    const row = modal.querySelectorAll('.c-contacts-form__row')

    const hideTl = anime.timeline()

    hideTl
      .add({
        targets: image,
        opacity: 0,
        duration: 0,
      })
      .add({
        targets: modalContent,
        opacity: 0,
        duration: 0,
      })
      .add({
        targets: immediate,
        opacity: 0,
        duration: 0,
      })
      .add({
        targets: modalClose,
        opacity: 0,
        duration: 0,
      })
      .add({
        targets: shapeLeft,
        skewX: '-20deg',
        translateX: '-70%',
        duration: 0,
      })
      .add({
        targets: shapeRight,
        skewX: '-20deg',
        translateX: '70%',
        duration: 0,
      })
      .add({
        targets: text,
        opacity: 0,
        translateY: '-12px',
        duration: 0,
      })
      .add({
        targets: title,
        opacity: 0,
        translateY: '-12px',
        duration: 0,
      })
      .add({
        targets: row,
        opacity: 0,
        translateY: '-12px',
        duration: 0,
      })
    }
  }

  const openModal = () => {
    const modal = $1('.c-contacts-modal')
    if (modal) {
      const modalContent = $1('.c-contacts-modal__content')
      const modalClose = $1('.c-contacts-modal__close')
      const image = $1('.c-contacts-modal__image')
      const shapeLeft = $1('.c-contacts-modal__image-shape--left')
      const shapeRight = $1('.c-contacts-modal__image-shape--right')

      const immediate = $1('.c-contacts-immediate')

      const text = modal.querySelector('.c-contacts__text')
      const title = modal.querySelector('.c-contacts__title')
      const row = modal.querySelectorAll('.c-contacts-form__row')

      const openTl = anime.timeline()

      if (!isAnimating) {
        isAnimating = true

        openTl
        .add({
          targets: modal,
          zIndex: 100000,
          duration: 1,
        })
        .add({
          targets: modalContent,
          opacity: 1,
          easing: 'linear',
          duration: 600,
        })
        .add({
          targets: image,
          opacity: 1,
          easing: 'linear',
          duration: 400,
        })
        .add({
          targets: shapeLeft,
          skewX: '-20deg',
          translateX: {
            value: '0%',
            easing: [0.694, 0.048, 0.335, 1.000],
          },
          duration: 450,
          offset: '-=350',
        })
        .add({
          targets: shapeRight,
          skewX: '-20deg',
          translateX: {
            value: '0%',
            easing: [0.694, 0.048, 0.335, 1.000],
          },
          duration: 450,
          offset: '-=350',
        })
        .add({
          targets: text,
          translateY: {
            value: '0%',
            easing: [0.694, 0.048, 0.335, 1.000],
          },
          opacity: {
            value: 1,
            easing: 'linear',
          },
          duration: 450,
        })
        .add({
          targets: title,
          translateY: {
            value: '0%',
            easing: [0.694, 0.048, 0.335, 1.000],
          },
          opacity: {
            value: 1,
            easing: 'linear',
          },
          duration: 450,
        })
        .add({
          targets: row,
          delay: (target, index) => index * 100,
          translateY: {
            value: '0%',
            easing: [0.694, 0.048, 0.335, 1.000],
          },
          opacity: {
            value: 1,
            easing: 'linear',
          },
          duration: 450,
        })
        .add({
          targets: immediate,
          opacity: 1,
          easing: 'linear',
          duration: 400,
        })
        .add({
          targets: modalClose,
          opacity: 1,
          easing: 'linear',
          duration: 600,
          complete: () => {
            isAnimating = false
          },
        })
      }
    }
  }

  const closeModal = () => {
    const modal = $1('.c-contacts-modal')
    if (modal) {
      const modalContent = $1('.c-contacts-modal__content')
      const modalClose = $1('.c-contacts-modal__close')
      const image = $1('.c-contacts-modal__image')
      const shapeLeft = $1('.c-contacts-modal__image-shape--left')
      const shapeRight = $1('.c-contacts-modal__image-shape--right')

      const immediate = $1('.c-contacts-immediate')

      const text = modal.querySelector('.c-contacts__text')
      const title = modal.querySelector('.c-contacts__title')
      const row = modal.querySelectorAll('.c-contacts-form__row')

      const closeTl = anime.timeline()

      if (!isAnimating) {
        isAnimating = true

        closeTl
        .add({
          targets: modalClose,
          opacity: 0,
          easing: 'linear',
          duration: 600,
        })
        .add({
          targets: row,
          delay: (target, index) => index * 100,
          translateY: {
            value: '-12px',
            easing: [0.694, 0.048, 0.335, 1.000],
          },
          opacity: {
            value: 0,
            easing: 'linear',
          },
          duration: 450,
          offset: '-=450',
        })
        .add({
          targets: title,
          translateY: {
            value: '-12px',
            easing: [0.694, 0.048, 0.335, 1.000],
          },
          opacity: {
            value: 0,
            easing: 'linear',
          },
          duration: 450,
          offset: '-=400',
        })
        .add({
          targets: immediate,
          opacity: 0,
          easing: 'linear',
          duration: 400,
        })
        .add({
          targets: text,
          translateY: {
            value: '-12px',
            easing: [0.694, 0.048, 0.335, 1.000],
          },
          opacity: {
            value: 0,
            easing: 'linear',
          },
          duration: 450,
          offset: '-=400',
        })
        .add({
          targets: shapeRight,
          skewX: '-20deg',
          translateX: {
            value: '70%',
            easing: [0.694, 0.048, 0.335, 1.000],
          },
          duration: 450,
          offset: '-=350',
        })
        .add({
          targets: shapeLeft,
          skewX: '-20deg',
          translateX: {
            value: '-70%',
            easing: [0.694, 0.048, 0.335, 1.000],
          },
          duration: 450,
          offset: '-=350',
        })
        .add({
          targets: image,
          opacity: 0,
          easing: 'linear',
          duration: 400,
        })
        .add({
          targets: modalContent,
          opacity: 0,
          easing: 'linear',
          duration: 600,
          offset: '-=450',
        })
        .add({
          targets: modal,
          zIndex: -1,
          duration: 1,
          complete: () => {
            isAnimating = false
          },
        })
      }
    }
  }

  const init = () => {
    const opener = $('.js-modal-open')
    const closer = $('.js-modal-close')

    hideModal()

    each(opener, (i, open) => {
      console.log('manage_click', open)
      open.addEventListener('click', () => {
        if (open.hasAttribute('data-id')) {
          const posID = open.getAttribute('data-id')
          const titolo = open.getAttribute('data-titolo')
          $1('.job-contact__posizione-hidden').value = titolo;
          $1('.job-contact__posizione-title-hidden').value = titolo;
          $1('.job-contact__posizione-id-hidden').value = posID;
        }
      
        openModal()
      })
    })

    each(closer, (i, close) => {
      close.addEventListener('click', () => {
        closeModal()
      })
    })
  }

  return {
    init,
  }
})()

export default ModalManager
